"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
/*
	intro : judge type of a instance
	Author : chenchao
	Date : 2019-05-22
*/


var _reactElement = require("./reactElement");

var Types = function Types(instance) {
  // if has no param , false would be returned
  if (arguments.length === 0) {
    console.warn("Sorry , Type function should be offered one param ");
    return false;
  } // null type


  if (instance === null) return "null"; // other simple types

  var insType = (typeof instance === "undefined" ? "undefined" : _typeof(instance)).toLowerCase(); // react element type

  if ((0, _reactElement.isReactElement)(instance)) {
    insType = "react element";
  } else {
    // other complex types
    insType = Object.prototype.toString.call(instance).toLowerCase().replace(/(\[|\])/g, "").slice(7);
  }

  return insType;
};

module.exports = Types;